<template>
  <div class="content">
    <h1 id="about">{{ msg }}</h1>
    <p>Puppy Coin is a deflationary memecoin built on Binance Smart Chain. Every transaction burns 1% of the tokens forever, so the supply constantly decreases and increases scarcity.</p>
    <p>Our goal is to build #PuppyGang into one of the strongest memecoin communities.</p>

    <div class="divider">🎾 🎾 🎾</div>

    <h3 id="tokenomics">Tokenomics</h3>
    <div>
      <p>Initial Supply 🐶: 10,000,000,000,000</p>
      <p>LP Tokens 🔒: 100% burned/locked</p>
      <p>1% burn 🔥 with every transaction</p>
    </div>

    <div class="divider">🎾 🎾 🎾</div>

    <h3>Burn Milestones</h3>
    <div>
      <p>Ultimately, $PUPPY’s success will be based on 2 things: a devoted community and attractive tokenomics, which encourage/reward long-term holders. In that regard, $PUPPY is actually very similar to Bitcoin, but cuter.</p>
      <p>At the center of $PUPPY’s model is the token burn, which decreases total supply indefinitely from the 10,000,000,000,000 initial max token supply.</p>
      <p>In addition, we are committing to burning tokens upon reaching certain milestones.</p>
      
      <div class="market-cap-burns-section rainbow">
        <p>🚀 $1M - 1% total supply burn 🔥</p>
        <p>🚀 $5M - 2% total supply burn 🔥</p>
        <p>🚀 $10M - 5% total supply burn 🔥</p>
        <p>🚀 $100M - 10% total supply burn 🔥</p>
      </div>
    </div>

    <div class="divider">🎾 🎾 🎾</div>

    <h3>#PuppyGang</h3>
    <ul class="list-icon-wrapper">
      <li class="list-icon"><a href="https://twitter.com/puppy_coin" target="_blank" rel="noopener"><img src="../assets/twitter.svg" /></a></li>
      <li class="list-icon"><a href="https://t.me/GOLDENPUPPYCOIN" target="_blank" rel="noopener"><img class="icon" src="../assets/telegram.svg"/></a></li>
    </ul>

    <img class="puppy-logo" src="../assets/puppy-footer.png"/>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: {
    msg: String
  },
}
</script>

<style scoped>
.content {
  max-width: 492px;
  margin: 0 auto;
  scroll-behavior: smooth;
}

p, li {
  font-size: 18px;
}
h3 {
  margin: 80px 0 0;
  font-size: 32px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
li.list-icon {
  display: flex;
  width: 45px;
  margin: 0 16px;
}
li.list-icon a {
  max-width: 45px;
  max-height: 45px;
  width: 45px;
}
li.list-icon img {
  height: 100%;
  min-height: 100%;
  width: auto;
}
a {
  color: #4900e9;
}
.list-icon-wrapper{
  display: flex;
  justify-content: center;
}
.puppy-logo {
  max-width: 300px;
}
.market-cap-burns-section {
  margin-top: 56px;
  background: #160909;
  color: white;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid white;
}
.market-cap-burns-section p {
  font-size: 16px;
}

@keyframes rotate {
	100% {
		transform: rotate(1turn);
	}
}

.rainbow {
	position: relative;
	z-index: 0;
	border-radius: 10px;
	overflow: hidden;
  color: black;
  padding: 12px 1rem;
}

.rainbow:before {
  content: '';
  position: absolute;
  z-index: -2;
  left: -50%;
  top: -50%;
  width: 200%;
  height: 200%;
  background-color: #399953;
  background-repeat: no-repeat;
  background-size: 50% 50%, 50% 50%;
  background-position: 0 0, 100% 0, 100% 100%, 0 100%;
  background-image: linear-gradient(#f88a8d, #f88a8d), linear-gradient(#ff9b00, #ff9b00), linear-gradient(#ff2600, #ff2600), linear-gradient(#2ba8ea, #2ba8ea);
  animation: rotate 4s linear infinite;
}

.rainbow:after {
  content: '';
  position: absolute;
  z-index: -1;
  left: 6px;
  top: 6px;
  width: calc(100% - 12px);
  height: calc(100% - 12px);
  background: white;
  border-radius: 5px;
}

.divider {
  margin-top: 80px;
  font-size: 24px;
}

@media (min-width: 768px) {
  p, li {
    font-size: 20px;
  }
  h3 {
    font-size: 32px;
    margin-top: 120px;
  }
  .rainbow {
    padding: 2rem;
  }
  .divider {
    margin-top: 120px;
  }
  .market-cap-burns-section p {
    font-size: 20px;
  }
}
</style>
